<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">A History of London Boroughs Through Beer Goggles (South East Edition)</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#introduction">Introduction</a></li>
<li id="toc-li-6"><a href="#/text/ch006#crawl-1-the-borough-of-southwark">Crawl 1: The Borough of Southwark</a>
</li>
<li id="toc-li-37"><span href="#/text/ch007#crawl-2-the-borough-of-lewisham" title="Link target outside of Sample">Crawl 2: The Borough of Lewisham</span>
</li>
<li id="toc-li-67"><span href="#/text/ch008#crawl-3-royal-borough-of-greenwich" title="Link target outside of Sample">Crawl 3: Royal Borough of Greenwich</span>
</li>
<li id="toc-li-97"><span href="#/text/ch009#crawl-4-the-borough-of-bexley" title="Link target outside of Sample">Crawl 4: The Borough of Bexley</span>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3d5735b0